<div class="navbar-brand">
  <router-link to="/" class="navbar-item nav-home">
    <span class="brand-first">Lars Nikander Frandsen</span>
  </router-link>
  <a
    class="navbar-item nav-icon nav-linkedin"
    href="https://www.linkedin.com/in/larsnikander"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="LinkedIn profile"
  >
    <i class="fab fa-linkedin-in" aria-hidden="true"></i>
  </a>
  <a
    class="navbar-item nav-icon nav-email"
    href="mailto:hello@larsnikander.com"
    aria-label="Email Lars Nikander Frandsen"
  >
    <i class="fas fa-envelope" aria-hidden="true"></i>
  </a>
  <a
    class="navbar-item nav-icon nav-github"
    href="https://github.com/larsnikander"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="GitHub profile"
  >
    <i class="fab fa-github" aria-hidden="true"></i>
  </a>
</div>
